export const CHAT_REF = 'chat/messages';

export default function (_this) {
  return {
    add (message) {
      return new Promise((resolve) => {
        getRef().push(message, (res) => {
          resolve(res)
        });
      })
    },
    getAll (cb) {
      getRef().once('value', (snapshot) => {
        const messages = [];
        const map = snapshot.val() || {};
        for (let key in map) {
          messages.push({
            id: key,
            ...map[key],
            date: new Date(map[key].date)
          });
        }
        cb(messages);
      });
    },
    deleteAll() {
      return getRef().remove()
    },
    delete (id) {
      getRef()
        .child(id)
        .remove()
    },
    getRef
  }

  function getRef() {
    return _this.getRef(CHAT_REF);
  }
}
